import { VehicleDataAge } from '../enums/vehicle-data-age.enum';
import { parseUtcTimestamp } from '@agilox/ui-common';

export const VEHICLE_DATA_OUTDATED_AFTER_HOURS = 12;

export const VEHICLE_DATA_CRITICAL_AFTER_HOURS = 24;

export const MILLISECONDS_PER_HOUR = 3600000;

export function vehicleDataAgeInHours(
	timestamp: string | null | undefined,
	now: number
): number | undefined {
	const parsed = parseUtcTimestamp(timestamp);
	return parsed === undefined ? undefined : (now - parsed) / MILLISECONDS_PER_HOUR;
}

export function vehicleDataAge(timestamp: string | null | undefined, now: number): VehicleDataAge {
	const ageInHours = vehicleDataAgeInHours(timestamp, now);

	if (ageInHours === undefined) {
		return VehicleDataAge.MISSING;
	}
	if (ageInHours >= VEHICLE_DATA_CRITICAL_AFTER_HOURS) {
		return VehicleDataAge.CRITICAL;
	}

	return ageInHours >= VEHICLE_DATA_OUTDATED_AFTER_HOURS
		? VehicleDataAge.OUTDATED
		: VehicleDataAge.UP_TO_DATE;
}
